import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
// Define Auth context
// eslint-disable-next-line react-refresh/only-export-components
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [role, setRole] = useState(null);
  const [reset_new, setResetNew] = useState(true);
  const [username, setUsername] = useState("");
  const token = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  // Function to login
  const authenticatedRoutes = (auth, reset_new) => {
    // if (auth && reset_new) {
    //   setTimeout(())
    //   navigate("/setup");
    // }
    if(auth && !reset_new){
 setTimeout(() => {
      if (role === "MASTER" || role === "CHIEF_ENGINEER") {
        navigate("/admin");
      } else if (role === "ENGINE_ROOM" || role === "BRIDGE") {
        navigate("/user");
      } else if (role === "SUPERADMIN") {
        navigate("/superadmin");
      } else if (
        role === "OWNER" ||
        role === "OWNERGROUP" ||
        role === "FLEET_MANAGER" ||
        role === "VESSEL_MANANGER"
      ) {
        navigate("/management");
      }
    },300);
    }
   
  };
  const login = (accessToken, role, username, ship_id, user_id, reset_new) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("role", role);
    localStorage.setItem("username", username);
    localStorage.setItem("ship_id", ship_id);
    localStorage.setItem("user_id", user_id);
    localStorage.setItem("reset_new", reset_new);
    authenticatedRoutes(accessToken, reset_new);

    setAccessToken(accessToken);
    setRole(role);
    setResetNew(reset_new);
    setUsername(username);
    setAuthenticated(true);
  };
  
  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("username");
    localStorage.removeItem("ship_id");
    localStorage.removeItem("reset_new");
    localStorage.removeItem("role");
    setAccessToken(null);
    setRole(null);
    setUsername("");
    setAuthenticated(false);
  };
  React.useEffect(() => {
    const role = localStorage.getItem("role");
    if (token) {
      authenticatedRoutes();
      setAuthenticated(true);
      setAccessToken(token);
      setRole(role);
    } else {
      navigate("/login");
    }
  }, [children, token]);
  return (
    <AuthContext.Provider
      value={{
        authenticated,
        accessToken,
        role,
        login,
        logout,
        reset_new,
        username,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
